import React, { useState } from 'react';
import '@coreui/coreui/dist/css/coreui.min.css';

import {
  CNavbar,
  CContainer,
  CNavbarBrand,
  CNavbarToggler,
  CCollapse,
  CNavbarNav,
  CNavItem,
  CNavLink,
} from '@coreui/react';

const TopBar = () => {
    const [visible, setVisible] = useState(false);
  
    return (
      <>
        <CNavbar expand="lg" colorScheme="light" className="bg-light">
        <CContainer fluid>
        <CNavbarBrand href="/">Hiba Q.Habib</CNavbarBrand>
        <CNavbarToggler
          aria-label="Toggle navigation"
          aria-expanded={visible}
          onClick={() => setVisible(!visible)}
        />
        <CCollapse className="navbar-collapse" visible={visible}>
          <CNavbarNav className="ms-auto navbar-nav-right-lg">
           
            <CNavItem>
              <CNavLink href="/education">Education</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink href="/experience">Experience</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink href="/competencies">Competencies</CNavLink>
            </CNavItem>
            <CNavItem>
            <CNavLink href="/Hiba_Qutbuddin_Habib_CV.pdf" download="Hiba_Qutbuddin_Habib_CV.pdf">
              Full CV
            </CNavLink>
            </CNavItem>
          </CNavbarNav>
        </CCollapse>
      </CContainer>
    </CNavbar>
  </>
);
    };
    export default TopBar;